/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    advertiserList: [],
    lobList: {}
};
const audience = createSlice({
    name: "audience",
    initialState: { ...initialState },
    reducers: {
        setAdvertiserList: (state, action) => {
            state.advertiserList = action.payload;
        },
        setLOBList: (state, action) => {
            const { account, list } = action.payload;
            state.lobList[account] = list;
        }
    }
});

const { reducer, actions } = audience;
export const {
    setAdvertiserList,
    setLOBList
} = actions;
export default reducer;
